/**
 *
 * Notification
 *
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { useInjectReducer } from 'utils/injectReducer';
import { makeSelectNotificationState } from './selectors';
import reducer from './reducer';
import { ToastContainer, toast } from 'react-toastify';
import styled from 'styled-components';
import { NOTIFICATION as NOTIFICATION_CONSTANT } from 'common/constants';

const DefaultNotificationToaster = styled(ToastContainer)`
  .Toastify__toast {
    border-radius: 10px;
    min-height: unset;
    padding: 1rem;
  }
  .Toastify__toast--success {
    background-color: ${p => p.theme.palette.success};
  }
  .Toastify__toast--warning {
    background-color: ${p => p.theme.palette.warning};
  }
  .Toastify__toast--error {
    background-color: ${p => p.theme.palette.error};
  }
  .Toastify__close-button {
    align-self: unset;
  }
`;

const AgentNotificationToaster = styled(ToastContainer)`
  .Toastify__toast {
    border-radius: 20px;
    min-height: unset;
    padding: 15px;
    width: 768px;
    left: -13rem;
    height: 70px;
  }
`;

export const Notification = props => {
  useInjectReducer({ key: 'notification', reducer });

  return (
    <>
      <DefaultNotificationToaster
        enableMultiContainer
        containerId={NOTIFICATION_CONSTANT.VARIANTS.DEFAULT}
      />
      <AgentNotificationToaster
        enableMultiContainer
        containerId={NOTIFICATION_CONSTANT.VARIANTS.AGENT_REQUEST}
      />
    </>
  );
};
Notification.propTypes = {};
export const mapStateToProps = (state, props) => {
  return createStructuredSelector({
    notification: makeSelectNotificationState(),
  });
};
export const mapDispatchToProps = dispatch => {
  return {};
};
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Notification);
